<ng-container *ngIf="!isMobile; else mobileToolbar">
  <mat-toolbar class="as-home-toolbar">
    <a [routerLink]="['']">
      <mat-icon
        class="as-logo as-pointer"
        svgIcon="ic-logo-alsuper.com"
      ></mat-icon>
    </a>
    <div class="as-vertical-separator green"></div>
    <div class="as-search-actions">
      <button
        mat-stroked-button
        class="as-sidenav-button"
        [matMenuTriggerFor]="deptMenu"
      >
        <mat-icon svgIcon="ic-menu"></mat-icon
        ><span
          class="as-font-green as-font as-font-13 as-font-bold as-text-department"
          >{{ 'HOME.TOOLBAR.departments' | translate }}</span
        >
      </button>
      <mat-menu xPosition="after" #deptMenu="matMenu" class="as-departments">
        <div class="as-departments-header-menu">
          <a [routerLink]="['/departamento']">
            <mat-label class="as-font-black-gray as-font as-font-14">
              {{ 'FILTER.allDepartments' | translate }}
            </mat-label>
          </a>
          <div class="as-dept-wrapper">
            <div *ngFor="let department of departments">
              <a [routerLink]="[department.department_url]">
                <div
                  class="as-row as-align-center as-gap-10 as-pointer as-py-10"
                >
                  <img
                    width="19px"
                    height="19px"
                    [src]="department.icon_url"
                    alt="Department icon"
                  />
                  <mat-label class="as-font-black-gray as-font as-font-14">{{
                    department.description | titlecase
                  }}</mat-label>
                </div>
              </a>
            </div>
          </div>
        </div>
      </mat-menu>
      <form
        autocomplete="off"
        class="as-search-toolbar"
        [formGroup]="searchForm"
      >
        <mat-form-field
          appearance="outline"
          color="accent"
          class="as-rounded-form-field"
        >
          <input
            matInput
            formControlName="keyword"
            autocomplete="off"
            (keyup.enter)="onNavigateResults()"
            (keydown.enter)="$event.preventDefault()"
            placeholder="{{ 'HOME.TOOLBAR.searchPlaceholder' | translate }}"
          />
          <mat-icon
            class="as-pointer"
            matSuffix
            svgIcon="ic-{{
              !searchForm.get('keyword')?.value ? 'search' : 'close-green'
            }}"
            (click)="cleanSearch()"
            class="as-icon-green-light"
          >
          </mat-icon>
        </mat-form-field>
        <div #results class="as-w100">
          <div class="as-results-container" *ngIf="shouldDisplay">
            <div class="as-suggestions-container">
              <div *ngIf="displayLoader">
                <ng-lottie width="70px" height="70px" [options]="options">
                </ng-lottie>
              </div>
              <mat-label
                class="as-roboto-slab as-font-16 as-font-bold as-font-blackish"
                *ngIf="mainProductsResult.length"
              >
                {{ 'HOME.TOOLBAR.suggestions' | translate }}
              </mat-label>
              <mat-label
                class="as-font as-font-16 as-font-error"
                *ngIf="!mainProductsResult.length && !displayLoader"
              >
                {{ 'HOME.TOOLBAR.emptySuggestions' | translate }}
                <mat-label class="as-font-blackish">
                  "{{ searchForm.get('keyword')?.value }}"
                </mat-label>
              </mat-label>
              <div class="as-results-chips" *ngIf="mainProductsResult.length">
                <button
                  (click)="
                    suggestProduct(mainProductsResult[0].short_description)
                  "
                  mat-flat-button
                  class="as-chip"
                >
                  <mat-label>
                    {{ mainProductsResult[0].short_description | titlecase }}
                  </mat-label>
                </button>
              </div>
              <div
                class="as-product-result"
                *ngFor="let product of mainProductsResult"
              >
                <a [routerLink]="product?.product_url">
                  <div
                    class="as-product-first-column"
                    (click)="
                      onClickProduct(product.short_description, product.id)
                    "
                  >
                    <div class="as-product-img">
                      <img
                        width="80"
                        height="80"
                        [ngSrc]="product?.image_url"
                        alt="Product img"
                        onerror="src = 'assets/images/default-product.svg'"
                      />
                      <div
                        class="as-product-discount"
                        *ngIf="
                          product.price !== product.regular_price &&
                          product.discount > 20 &&
                          product?.smart_offer === ''
                        "
                      >
                        <mat-label class="as-font as-font-white as-font-13">
                          -{{ product.discount }}%
                        </mat-label>
                      </div>
                    </div>
                    <div class="as-name-column">
                      <mat-label
                        class="as-product-name as-font as-font-blackish as-font-14"
                      >
                        {{ product.description | titlecase }}
                      </mat-label>
                      <mat-label class="as-font as-font-10 as-font-grey-7e">
                        {{ product?.packing }}
                      </mat-label>
                    </div>
                  </div>
                </a>
                <div class="as-row as-w20 as-justify-se">
                  <div class="as-favorite-price">
                    <div class="as-column">
                      <mat-label
                        *ngIf="
                          product?.smart_offer !== '' &&
                            product?.offer_type === 1;
                          else normalsOfferPrice
                        "
                        class="as-font as-font-bold as-font-error"
                      >
                        {{ product?.smart_offer | currency : '$' }}
                      </mat-label>
                      <ng-template #normalsOfferPrice>
                        <mat-label
                          class="as-font-black-gray as-font-semibold"
                          [ngClass]="
                            product.price === product.regular_price
                              ? ''
                              : 'as-font-error'
                          "
                        >
                          {{ product?.price | currency : '$' }}
                        </mat-label>
                      </ng-template>
                      <mat-label
                        class="as-font-line-through as-font-black-gray"
                        *ngIf="product.price !== product.regular_price"
                      >
                        {{ product?.regular_price | currency : '$' }}
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="as-show-more"
              *ngIf="mainProductsResult.length"
              (click)="onNavigateResults()"
            >
              <mat-label class="as-font-bold as-font-14 as-font-underline">
                {{ 'HOME.TOOLBAR.showAllResults' | translate }}
              </mat-label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="as-user-actions">
      <a
        [routerLink]="['/autenticacion/iniciar-sesion']"
        class="as-font-green as-font as-font-13 as-font-bold as-pointer as-font-underline"
        *ngIf="!user"
      >
        {{ 'AUTH.signin' | translate }}
      </a>
      <button mat-button *ngIf="user" [matMenuTriggerFor]="menu">
        <div class="cont">
          <div *ngIf="avatarLoading" class="as-spinner-green">
            <mat-spinner [diameter]="24"></mat-spinner>
          </div>
          <div *ngIf="!avatarLoading" class="img-container">
            <mat-label
              class="as-font-white as-font as-font-normal as-font-14"
              >{{ user.name | slice : 0 : 1 | uppercase }}</mat-label
            >
            <!-- <img
              width="28"
              height="28"
              class="as-profile-defualt"
              [ngSrc]="avatar.avatar"
            /> -->
          </div>
          <div class="as-user-container">
            <mat-label class="as-font as-font-16"> {{ user.name }} </mat-label>
            <mat-label class="as-font">
              {{ 'MENU.profile' | translate }}
            </mat-label>
          </div>
        </div>
      </button>
      <mat-menu #menu="matMenu">
        <div
          (click)="checkIfExistsClubAlsuperCard()"
          class="as-header-menu as-pointer"
        >
          <div>
            <div class="as-row as-align-center as-justify-sb">
              <div class="as-row as-align-center as-gap-15">
                <mat-icon
                  class="as-club-alsuper-logo"
                  svgIcon="ic-club-alsuper-logo"
                ></mat-icon>
                <div
                  *ngIf="
                    !card_owner && !clubAmmount && !clubCardAmount;
                    else existClubAlsuper
                  "
                  class="as-font as-font-white as-column as-font-w-700"
                >
                  <mat-label class="as-font-12">{{
                    'CLUB.addClubCard' | translate
                  }}</mat-label>
                  <mat-label class="as-font-10">{{
                    'CLUB.getPointsFree' | translate
                  }}</mat-label>
                </div>
                <ng-template #existClubAlsuper>
                  <div class="as-font as-font-white as-column as-font-w-700">
                    <mat-label class="as-font-12">{{ card_owner }}</mat-label>
                    <mat-label class="as-font-10"
                      >****{{ user?.membership?.slice(-4) }} -
                      {{ clubAmmount }} puntos</mat-label
                    >
                  </div>
                </ng-template>
              </div>
              <mat-icon class="as-arrow" svgIcon="ic-arrow-right"></mat-icon>
            </div>
            <div
              class="as-card-info as-row as-align-center as-justify-end as-gap-10"
              *ngIf="sharedCard"
            >
              <div class="as-info as-font as-font-10 as-font-w-700">
                {{ clubCardAmount }}
              </div>
              <mat-icon
                matTooltip="Puedes usar tu tarjeta Club Alsuper con hasta 3 cuentas diferentes."
                [matTooltipPosition]="'below'"
                matTooltipHideDelay="100000"
                svgIcon="ic-question"
              ></mat-icon>
            </div>
          </div>
        </div>
        <a [routerLink]="item.route" *ngFor="let item of menuList">
          <button mat-menu-item (click)="onNavigate(item.route)">
            {{ item.label | translate }}
          </button>
        </a>
        <a [routerLink]="['/ayuda']">
          <button mat-menu-item (click)="onNavigate('ayuda')">
            {{ 'AUTH.help' | translate }}
          </button>
        </a>
        <button
          mat-menu-item
          class="as-signout-item"
          (click)="onNavigate('signout')"
        >
          {{ 'GENERAL.signout' | translate }}
        </button>
      </mat-menu>
      <div
        *ngIf="user"
        class="as-row as-pointer as-align-center as-cart-button"
        (click)="onDisplayCart()"
      >
        <ng-container *ngIf="totalItems; else noBadge">
          <mat-icon
            matSuffix
            svgIcon="ic-cart"
            matBadgeSize="small"
            matBadge="{{ totalItems }}"
            matBadgeColor="warn"
          ></mat-icon>
          <!-- <mat-label class="as-font-black as-font-16">
            {{ totalAmount | currency : '$' }}
          </mat-label> -->
        </ng-container>
        <ng-template #noBadge>
          <mat-icon matSuffix svgIcon="ic-cart"></mat-icon>
          <!-- <mat-label class="as-font-black as-font-16">
            {{ totalAmount | currency : '$' }}
          </mat-label> -->
        </ng-template>
      </div>
    </div>
  </mat-toolbar>
  <mat-toolbar
    class="as-second-toolbar"
    [ngClass]="showBlack ? 'as-black' : 'as-green'"
  >
    <div class="as-toolbar-actions" [ngClass]="!user ? 'no-login' : ''">
      <a [routerLink]="action.route" *ngFor="let action of actions">
        <button mat-button (click)="onNavigate(action.route)">
          <mat-label class="as-font as-font-14 as-font-white">
            {{ action.label | translate }}
          </mat-label>
        </button>
      </a>
    </div>
    <div class="as-invite-mode" *ngIf="!user">
      <mat-icon
        (click)="openCpSelect()"
        class="as-pointer"
        svgIcon="ic-bxs-truck"
      ></mat-icon>
      <ng-container *ngIf="selectedStore?.displayName; else noSelect">
        <mat-label
          (click)="openCpSelect()"
          class="as-pointer as-overflow-address as-font as-font-13 as-font-white as-line-height-normal"
          >{{ 'HOME.TOOLBAR.in' | translate }}
          <span class="as-font-bold">{{
            selectedStore.displayName
          }}</span></mat-label
        >
      </ng-container>
      <ng-template #noSelect>
        <mat-label
          (click)="openCpSelect()"
          class="as-pointer as-overflow-address as-font as-font-13 as-font-white as-line-height-normal"
          >{{ 'HOME.TOOLBAR.in' | translate }}
          {{ 'HOME.TOOLBAR.leones' | translate }}</mat-label
        >
      </ng-template>
    </div>
    <div
      class="as-shipping as-pointer"
      [matMenuTriggerFor]="deliveryMenu"
      #deliveryMenuTrigger="matMenuTrigger"
      *ngIf="user"
      (click)="getAddresses()"
      (click)="onClickChangeType()"
    >
      <mat-icon
        class="as-ic-shipping"
        svgIcon="ic-{{
          selectedAddress?.type === 'pickup' ? 'pickup' : 'shipping'
        }}"
      >
      </mat-icon>
      <ng-container *ngIf="selectedAddress; else addressNotSelected">
        <div class="as-row as-align-center">
          <mat-label
            class="as-overflow-address as-font as-font-14 as-font-white as-line-height-normal"
          >
            {{
              selectedAddress?.type === 'delivery'
                ? ('HOME.TOOLBAR.sendTo' | translate)
                : ('HOME.TOOLBAR.pickupAt' | translate)
            }}
            {{ selectedAddress.displayName }}
          </mat-label>
          <mat-icon svgIcon="ic-dropdown"></mat-icon>
        </div>
      </ng-container>
      <ng-template #addressNotSelected>
        <mat-label
          class="as-font as-font-normal as-font-14 as-font-white as-font-underline"
        >
          {{ 'HOME.TOOLBAR.localization' | translate }}
        </mat-label>
      </ng-template>
    </div>
    <div
      class="as-pointer"
      [matMenuTriggerFor]="storeTypeMenu"
      #storeTypeMenuTrigger="matMenuTrigger"
      *ngIf="selectedAddress?.type === 'delivery'"
      (click)="getAddresses()"
      (click)="deliveryMenuTrigger.closeMenu()"
    >
      <div class="as-row as-align-center">
        <img
          class="as-store-type"
          width="64"
          height="24"
          ngSrc="{{
            selectedAddress.storeType === 'fresh_market'
              ? 'assets/icons/Fresh.svg'
              : selectedAddress.storeType === 'alsuper'
              ? 'assets/icons/Alsuper.svg'
              : 'assets/icons/AlsuperPlus.svg'
          }}"
        />
        <mat-icon svgIcon="ic-dropdown"></mat-icon>
      </div>
    </div>
    <mat-menu #storeTypeMenu="matMenu" [hasBackdrop]="false">
      <div class="as-menu-header" (click)="$event.stopPropagation()">
        <mat-label class="as-font-16 as-font-bold as-roboto-slab">
          {{
            alsuperTypes[0] !== null ||
            alsuperTypes[1] !== null ||
            alsuperTypes[2] ||
            null
              ? ('HOME.TOOLBAR.selectStore' | translate)
              : ('HOME.TOOLBAR.noTypes' | translate)
          }}
        </mat-label>
      </div>
      <div
        class="as-image-wrap"
        *ngFor="let type of alsuperTypes; let i = index"
        (click)="onSelectingStoreType(type)"
      >
        <div *ngIf="type !== null" class="as-type-image">
          <mat-icon [svgIcon]="type.image" />
          <div class="texts">
            <p class="as-font as-font-semibold as-font-14">
              {{ type.value }}
            </p>
          </div>
        </div>
        <div
          class="line"
          *ngIf="
            alsuperTypes[i + 1] !== null &&
            alsuperTypes[i + 1] !== undefined &&
            alsuperTypes[i] !== null &&
            alsuperTypes[i] !== undefined
          "
        ></div>
      </div>
    </mat-menu>
    <mat-menu #deliveryMenu="matMenu" [hasBackdrop]="false">
      <ng-container
        *ngIf="deliveryType && !displayAlsuperTypes"
        (click)="$event.stopPropagation()"
      >
        <div class="as-menu-header" (click)="$event.stopPropagation()">
          <mat-label class="as-font-16 as-font-bold as-roboto-slab">
            {{ 'PURCHASE.homeDelivery2' | translate }}
          </mat-label>
        </div>
        <div
          *ngIf="addressesLoading"
          class="as-row as-justify-center as-spinner-green"
        >
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
        <div *ngIf="!addressesLoading">
          <div
            class="as-address-item"
            *ngFor="let address of addresses"
            (click)="onSelectingAddress(address, $event)"
            (click)="$event.stopPropagation()"
          >
            <mat-icon
              svgIcon="ic-{{ address.default ? 'pin-red' : 'radio-off' }}"
            ></mat-icon>
            <div class="as-column as-font-12">
              <mat-label class="as-font-semibold">
                {{ address.tag | translate }}
              </mat-label>
              <mat-label>
                {{ address.detail
                }}<!-- {{ address.number }}, {{ address.suburb }} --></mat-label
              >
            </div>
          </div>
        </div>
        <div
          mat-menu-item
          class="as-add-address-item"
          (click)="addAddressDialog()"
        >
          <mat-icon svgIcon="ic-add"></mat-icon>
          <mat-label class="as-font-green as-font-medium">
            {{ 'ADDRESSES.add' | translate }}
          </mat-label>
        </div>
        <div
          mat-menu-item
          class="as-change-delivery-item"
          (click)="$event.stopPropagation()"
          (click)="onChangeDeliveryType()"
        >
          <mat-icon svgIcon="ic-change" color="warn"></mat-icon>
          <mat-label class="as-font-warn as-font-bold as-font-underline">
            {{ 'ADDRESSES.changeToPickup' | translate }}
          </mat-label>
        </div>
      </ng-container>
      <ng-container
        *ngIf="deliveryType && displayAlsuperTypes"
        (click)="$event.stopPropagation()"
      >
        <div class="as-menu-header" (click)="$event.stopPropagation()">
          <mat-label class="as-font-16 as-font-bold as-roboto-slab">
            {{
              alsuperTypes[0] !== null ||
              alsuperTypes[1] !== null ||
              alsuperTypes[2] ||
              null
                ? ('HOME.TOOLBAR.selectStore' | translate)
                : ('HOME.TOOLBAR.noTypes' | translate)
            }}
          </mat-label>
        </div>
        <div
          class="as-image-wrap"
          *ngFor="let type of alsuperTypes; let i = index"
          (click)="onSelectingStoreType(type)"
        >
          <div *ngIf="type !== null" class="as-type-image">
            <mat-icon [svgIcon]="type.image" />
            <div class="texts">
              <p class="as-font as-font-semibold as-font-14">
                {{ type.value }}
              </p>
            </div>
          </div>
          <div
            class="line"
            *ngIf="
              alsuperTypes[i + 1] !== null &&
              alsuperTypes[i + 1] !== undefined &&
              alsuperTypes[i] !== null &&
              alsuperTypes[i] !== undefined
            "
          ></div>
        </div>
      </ng-container>
    </mat-menu>
    <div style="display: none" class="as-estimated-time">
      <mat-icon svgIcon="ic-time"></mat-icon>
      <mat-label class="as-font as-font-10 as-font-green">90 min</mat-label>
    </div>
  </mat-toolbar>
</ng-container>
<ng-template #mobileToolbar>
  <div (scroll)="onScroll()">
    <mat-toolbar
      [ngClass]="{ 'as-home-toolbar-mobile-dinamic': deleteSpaceTop }"
      class="as-home-toolbar-mobile"
    >
      <mat-toolbar-row class="as-menu-toolbar">
        <div class="as-row as-align-center">
          <!-- <mat-icon svgIcon="ic-menu-mobile" (click)="onOpen()"></mat-icon> -->
          <a [routerLink]="['/']">
            <mat-icon
              class="as-logo as-pointer"
              svgIcon="ic-logo-alsuper.com"
              (click)="onNavigate('')"
            ></mat-icon>
          </a>
        </div>
        <div class="as-row as-align-center">
          <ng-container *ngIf="user; else loginButton">
            <div *ngIf="avatarLoading" class="as-spinner-green">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
            <mat-icon
              (click)="openMobileMenu()"
              *ngIf="!avatarLoading"
              class="as-profile-defualt as-pointer"
              svgIcon="ic-menu-mobile"
            ></mat-icon>
            <!-- <img
              *ngIf="!avatarLoading"
              [matMenuTriggerFor]="menu"
              class="as-profile-defualt"
              width="28"
              height="28"
              [ngSrc]="avatar.avatar"
            /> -->
            <mat-menu #menu="matMenu">
              <div
                (click)="checkIfExistsClubAlsuperCard()"
                class="as-header-menu"
              >
                <div>
                  <div class="as-row as-align-center as-justify-sb">
                    <div class="as-row as-align-center as-gap-15">
                      <mat-icon
                        class="as-club-alsuper-logo"
                        svgIcon="ic-club-alsuper-logo"
                      ></mat-icon>
                      <div
                        *ngIf="
                          !card_owner && !clubAmmount && !clubCardAmount;
                          else existClubAlsuperMobile
                        "
                        class="as-font as-font-white as-column as-font-w-700"
                      >
                        <mat-label class="as-font-12">{{
                          'CLUB.addClubCard' | translate
                        }}</mat-label>
                        <mat-label class="as-font-10">{{
                          'CLUB.getPointsFree' | translate
                        }}</mat-label>
                      </div>
                      <ng-template #existClubAlsuperMobile>
                        <div
                          class="as-font as-font-white as-column as-font-w-700"
                        >
                          <mat-label class="as-font-12">{{
                            card_owner
                          }}</mat-label>
                          <mat-label class="as-font-10"
                            >****{{ user.membership.slice(-4) }} -
                            {{ clubAmmount }} puntos</mat-label
                          >
                        </div>
                      </ng-template>
                    </div>
                    <mat-icon
                      class="as-arrow"
                      svgIcon="ic-arrow-right"
                    ></mat-icon>
                  </div>
                  <div
                    class="as-card-info as-row as-align-center as-justify-end as-gap-10"
                    *ngIf="sharedCard"
                  >
                    <div class="as-info as-font as-font-10 as-font-w-700">
                      {{ clubCardAmount }}
                    </div>
                    <mat-icon
                      matTooltip="Puedes usar tu tarjeta Club Alsuper con hasta 3 cuentas diferentes."
                      [matTooltipPosition]="'below'"
                      matTooltipHideDelay="100000"
                      svgIcon="ic-question"
                    ></mat-icon>
                  </div>
                </div>
              </div>
              <a [routerLink]="item.route" *ngFor="let item of menuList">
                <button mat-menu-item (click)="onNavigate(item.route)">
                  {{ item.label | translate }}
                </button>
              </a>
              <button
                mat-menu-item
                class="as-signout-item"
                (click)="onNavigate('signout')"
              >
                {{ 'GENERAL.signout' | translate }}
              </button>
            </mat-menu>
          </ng-container>
          <ng-template #loginButton>
            <!-- <a [routerLink]="['/autenticacion/iniciar-sesion']">
              <button mat-icon-button>
                <mat-icon svgIcon="ic-profile-user"></mat-icon>
              </button>
            </a> -->
            <mat-icon
              (click)="openMobileMenu()"
              class="as-profile-defualt as-pointer"
              svgIcon="ic-menu-mobile"
            ></mat-icon>
          </ng-template>
          <ng-container *ngIf="totalItems; else noBadgeMobile">
            <mat-icon
              matSuffix
              svgIcon="ic-cart"
              matBadgeSize="medium"
              matBadge="{{ totalItems }}"
              matBadgeColor="warn"
              (click)="onDisplayCart()"
            ></mat-icon>
          </ng-container>
          <ng-template #noBadgeMobile>
            <mat-icon
              matSuffix
              svgIcon="ic-cart"
              (click)="onDisplayCart()"
            ></mat-icon>
          </ng-template>
        </div>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <form
          autocomplete="off"
          class="as-search-toolbar-mobile"
          [formGroup]="searchForm"
        >
          <mat-form-field
            appearance="outline"
            color="accent"
            class="as-rounded-form-field"
          >
            <input
              matInput
              formControlName="keyword"
              autocomplete="off"
              (keyup.enter)="onNavigateResults()"
              placeholder="{{ 'HOME.TOOLBAR.searchPlaceholder' | translate }}"
            />
            <mat-icon
              matSuffix
              svgIcon="ic-{{
                !searchForm.get('keyword')?.value ? 'search' : 'close-green'
              }}"
              (click)="cleanSearch()"
              class="as-icon-green-light"
            >
            </mat-icon>
          </mat-form-field>
          <div #results>
            <div class="as-results-container-mobile" *ngIf="shouldDisplay">
              <mat-label
                class="as-font as-font-16 as-font-error"
                *ngIf="!mainProductsResult.length"
              >
                {{ 'HOME.TOOLBAR.emptySuggestions' | translate }}
                <mat-label class="as-font-blackish">
                  "{{ searchForm.get('keyword')?.value }}"
                </mat-label>
              </mat-label>
              <a
                [routerLink]="product?.product_url"
                *ngFor="let product of mainProductsResult"
              >
                <div
                  class="as-product-result"
                  (click)="
                    onClickProduct(product.short_description, product.id)
                  "
                >
                  <mat-label
                    class="as-product-name as-font as-font-blackish as-font-14"
                  >
                    {{ product.description | titlecase }}
                  </mat-label>
                </div>
              </a>
              <div
                class="as-show-more"
                *ngIf="mainProductsResult.length"
                (click)="onNavigateResults()"
              >
                <mat-label class="as-font-bold as-font-14 as-font-underline">
                  {{ 'HOME.TOOLBAR.showAllResults' | translate }}
                </mat-label>
              </div>
            </div>
          </div>
        </form>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
  <mat-toolbar
    [ngClass]="
      !ajustToolbar && deleteSpaceTop
        ? 'as-second-toolbar-mobile-dinamic'
        : ajustToolbar && deleteSpaceTop
        ? 'as-second-toolbar-mobile-dinamic'
        : ajustToolbar && !deleteSpaceTop
        ? 'as-second-toolbar-mobile-dinamic'
        : ''
    "
    class="as-second-toolbar-mobile"
    color="accent"
    *ngIf="user; else noAuth"
  >
    <div
      class="as-pointer"
      [matMenuTriggerFor]="storeTypeMenu"
      #storeTypeMenuTrigger="matMenuTrigger"
      *ngIf="selectedAddress.type === 'delivery'"
      (click)="getAddresses()"
      (click)="deliveryMenuTrigger.closeMenu()"
    >
      <div class="as-row as-align-center">
        <mat-icon
          class="as-store-type"
          svgIcon="{{
            selectedAddress.storeType === 'fresh_market'
              ? 'ic-alsuper-green'
              : selectedAddress.storeType === 'alsuper'
              ? 'ic-alsuper-blue'
              : 'ic-alsuper-red'
          }}"
        />
        <!-- <mat-icon svgIcon="ic-dropdown"></mat-icon> -->
      </div>
    </div>
    <mat-menu #storeTypeMenu="matMenu" [hasBackdrop]="false">
      <div class="as-menu-header" (click)="$event.stopPropagation()">
        <mat-label class="as-font-16 as-font-bold as-roboto-slab">
          {{
            alsuperTypes[0] !== null ||
            alsuperTypes[1] !== null ||
            alsuperTypes[2] ||
            null
              ? ('HOME.TOOLBAR.selectStore' | translate)
              : ('HOME.TOOLBAR.noTypes' | translate)
          }}
        </mat-label>
      </div>
      <div
        class="as-image-wrap"
        *ngFor="let type of alsuperTypes; let i = index"
        (click)="onSelectingStoreType(type)"
      >
        <div *ngIf="type !== null" class="as-type-image">
          <mat-icon [svgIcon]="type.image" />
          <div class="texts">
            <p class="as-font as-font-semibold as-font-14">
              {{ type.value }}
            </p>
          </div>
        </div>
        <div
          class="line"
          *ngIf="
            alsuperTypes[i + 1] !== null &&
            alsuperTypes[i + 1] !== undefined &&
            alsuperTypes[i] !== null &&
            alsuperTypes[i] !== undefined
          "
        ></div>
      </div>
    </mat-menu>
    <mat-menu #deliveryMenu="matMenu" [hasBackdrop]="false">
      <ng-container
        *ngIf="deliveryType && !displayAlsuperTypes"
        (click)="$event.stopPropagation()"
      >
        <div class="as-menu-header" (click)="$event.stopPropagation()">
          <mat-label class="as-font-16 as-font-bold as-roboto-slab">
            {{ 'PURCHASE.homeDelivery2' | translate }}
          </mat-label>
        </div>
        <div
          class="as-address-item"
          *ngFor="let address of addresses"
          (click)="onSelectingAddress(address, $event)"
          (click)="$event.stopPropagation()"
        >
          <mat-icon
            svgIcon="ic-{{ address.default ? 'pin-red' : 'radio-off' }}"
          ></mat-icon>
          <div class="as-column as-font-12">
            <mat-label class="as-font-semibold">
              {{ address.tag | translate }}
            </mat-label>
            <mat-label>
              {{ address.detail }} {{ address.number }}, {{ address.suburb }}
            </mat-label>
          </div>
        </div>
        <div
          mat-menu-item
          class="as-add-address-item"
          (click)="addAddressDialog()"
        >
          <mat-icon svgIcon="ic-add"></mat-icon>
          <mat-label class="as-font-green as-font-medium">
            {{ 'ADDRESSES.add' | translate }}
          </mat-label>
        </div>
        <div
          mat-menu-item
          class="as-change-delivery-item"
          (click)="$event.stopPropagation()"
          (click)="onChangeDeliveryType()"
        >
          <mat-icon svgIcon="ic-change" color="warn"></mat-icon>
          <mat-label class="as-font-warn as-font-bold as-font-underline">
            {{ 'ADDRESSES.changeToPickup' | translate }}
          </mat-label>
        </div>
      </ng-container>
      <ng-container
        *ngIf="deliveryType && displayAlsuperTypes"
        (click)="$event.stopPropagation()"
      >
        <div class="as-menu-header" (click)="$event.stopPropagation()">
          <mat-label class="as-font-16 as-font-bold as-roboto-slab">
            {{
              alsuperTypes[0] !== null ||
              alsuperTypes[1] !== null ||
              alsuperTypes[2] ||
              null
                ? ('HOME.TOOLBAR.selectStore' | translate)
                : ('HOME.TOOLBAR.noTypes' | translate)
            }}
          </mat-label>
        </div>
        <div
          class="as-image-wrap"
          *ngFor="let type of alsuperTypes; let i = index"
          (click)="onSelectingStoreType(type)"
        >
          <div *ngIf="type !== null" class="as-type-image">
            <mat-icon [svgIcon]="type.image" />
            <div class="texts">
              <p class="as-font as-font-semibold as-font-14">
                {{ type.value }}
              </p>
            </div>
          </div>
          <div
            class="line"
            *ngIf="
              alsuperTypes[i + 1] !== null &&
              alsuperTypes[i + 1] !== undefined &&
              alsuperTypes[i] !== null &&
              alsuperTypes[i] !== undefined
            "
          ></div>
        </div>
      </ng-container>
    </mat-menu>
    <div class="as-vertical-separator white"></div>
    <div
      class="as-shipping as-pointer"
      [matMenuTriggerFor]="deliveryMenu"
      #deliveryMenuTrigger="matMenuTrigger"
      *ngIf="user"
      (click)="getAddresses()"
      (click)="onClickChangeType()"
    >
      <mat-icon
        class="as-ic-shipping"
        svgIcon="ic-{{
          selectedAddress?.type === 'pickup' ? 'pickup' : 'shipping'
        }}"
      >
      </mat-icon>
      <ng-container *ngIf="selectedAddress; else addressNotSelected">
        <div class="as-row as-align-center">
          <mat-label
            class="as-overflow-address as-font as-font-14 as-font-white as-line-height-normal"
          >
            {{ selectedAddress.displayName }}
          </mat-label>
          <mat-icon svgIcon="ic-dropdown"></mat-icon>
        </div>
      </ng-container>
      <ng-template #addressNotSelected>
        <mat-label
          class="as-font as-font-normal as-font-14 as-font-white as-font-underline"
        >
          {{ 'HOME.TOOLBAR.localization' | translate }}
        </mat-label>
      </ng-template>
    </div>
    <div style="display: none" class="as-estimated-time">
      <mat-icon svgIcon="ic-time"></mat-icon>
      <mat-label class="as-font as-font-10 as-font-green">90 min</mat-label>
    </div>
  </mat-toolbar>
  <ng-template #noAuth>
    <mat-toolbar
      [ngClass]="
        !ajustToolbar && deleteSpaceTop
          ? 'as-second-toolbar-mobile-dinamic'
          : ajustToolbar && deleteSpaceTop
          ? 'as-second-toolbar-mobile-dinamic'
          : ajustToolbar && !deleteSpaceTop
          ? 'as-second-toolbar-mobile-dinamic'
          : ''
      "
      class="as-second-toolbar-mobile"
      color="accent"
    >
      <div class="as-invite-mode" *ngIf="!user">
        <mat-icon
          (click)="openCpSelect()"
          class="as-pointer"
          svgIcon="ic-bxs-truck"
        ></mat-icon>
        <ng-container *ngIf="selectedStore?.displayName; else noSelectMobile">
          <mat-label
            (click)="openCpSelect()"
            class="as-pointer as-overflow-address as-font as-font-13 as-font-white as-line-height-normal"
            >{{ 'HOME.TOOLBAR.in' | translate }}
            <span class="as-font-bold">{{
              selectedStore.displayName
            }}</span></mat-label
          >
        </ng-container>
        <ng-template #noSelectMobile>
          <mat-label
            (click)="openCpSelect()"
            class="as-pointer as-overflow-address as-font as-font-13 as-font-white as-line-height-normal"
            >{{ 'HOME.TOOLBAR.in' | translate }}
            {{ 'HOME.TOOLBAR.leones' | translate }}</mat-label
          >
        </ng-template>
      </div>
      <div class="init-session">
        <a
          [routerLink]="['/autenticacion/iniciar-sesion']"
          class="as-font-white as-font as-font-13 as-font-bold as-pointer as-font-underline"
        >
          {{ 'AUTH.signin' | translate }}
        </a>
      </div>
    </mat-toolbar>
  </ng-template>
</ng-template>
